export interface FamilyMember {
  id: string
  firstName: string
  lastName: string
  role: string
  initials: string
  hasCard: boolean
  photo: string
  canEdit: boolean
}

export interface EditableField {
  id: string
  label: string
  placeholder: string
  requiresProof: boolean
  proofLabel?: string
}

export const editableFields: EditableField[] = [
  {
    id: 'prenom',
    label: 'Prénom',
    placeholder: 'Marianne',
    requiresProof: true,
    proofLabel: 'Certificat de naissance ou pièce d’identité',
  },
  {
    id: 'nom',
    label: 'Nom de famille',
    placeholder: 'Caldwell',
    requiresProof: true,
    proofLabel: 'Pièce d’identité officielle',
  },
  { id: 'genre', label: 'Genre', placeholder: 'Femme', requiresProof: false },
  { id: 'photo', label: 'Photo de la carte', placeholder: 'Nouvelle photo', requiresProof: false },
  {
    id: 'adresse',
    label: 'Adresse',
    placeholder: '366, chemin Lakeshore, Beaconsfield',
    requiresProof: false,
    proofLabel: 'Preuve de résidence (bail, compte de taxes, permis de conduire)',
  },
]

export const verifiedAddresses = [
  { id: 'lakeshore', label: '366, chemin Lakeshore, Beaconsfield', note: 'Adresse principale · vérifiée' },
  { id: 'taywood', label: '130, Taywood Drive, Beaconsfield', note: 'Deuxième propriété · vérifiée' },
]

export const memberValues: Record<string, Record<string, string>> = {
  marianne: {
    prenom: 'Marianne',
    nom: 'Caldwell',
    genre: 'Femme',
    photo: 'Photo actuelle',
    adresse: '366, chemin Lakeshore, Beaconsfield',
  },
  eric: {
    prenom: 'Éric',
    nom: 'Lavoie',
    genre: 'Homme',
    photo: 'Photo actuelle',
    adresse: '366, chemin Lakeshore, Beaconsfield',
  },
  emma: {
    prenom: 'Emma',
    nom: 'Lavoie',
    genre: 'Femme',
    photo: 'Photo actuelle',
    adresse: '366, chemin Lakeshore, Beaconsfield',
  },
}

export const citizen = {
  firstName: 'Marianne',
  lastName: 'Caldwell',
  initials: 'MC',
  city: 'Beaconsfield',
}

export const cardCredentials = ['Résident', 'Centre récréatif', 'Bibliothèque', 'Loisirs']

export interface WalletCard {
  id: string
  label: string
  number: string
  badge: string
  note: string
}

export const walletCards: WalletCard[] = [
  {
    id: 'citoyenne',
    label: 'Carte numérique',
    number: '0040327823',
    badge: 'Résident',
    note: 'Accès au Centre récréatif valide jusqu’au 28 octobre',
  },
  {
    id: 'loisirs',
    label: 'Loisirs',
    number: '0093612477',
    badge: 'Résident',
    note: 'Natation d’Emma · samedi 10 h',
  },
  {
    // L'abonnement vit dans le catalogue de la bibliothèque (SirsiDynix Horizon) :
    // la carte citoyenne en est le porteur, les emprunts restent synchronisés.
    id: 'bibliotheque',
    label: 'Bibliothèque',
    number: '0071845209',
    badge: 'Abonnée',
    note: '2 documents à rapporter avant le 10 octobre',
  },
]

export interface CardAsset {
  id: string
  name: string
  detail: string
  icon: 'home' | 'cottage' | 'car' | 'bike'
  /** Pastille bleue : dossier à jour ; grise : action requise. */
  active: boolean
}

export const properties: CardAsset[] = [
  { id: 'lakeshore', name: '366, chemin Lakeshore', detail: 'Résidence', icon: 'home', active: true },
  { id: 'taywood', name: '130, Taywood Drive', detail: 'Deuxième propriété', icon: 'cottage', active: true },
]

export const vehicles: CardAsset[] = [
  { id: 'rav4', name: 'Toyota RAV4', detail: 'Vignette active', icon: 'car', active: true },
  { id: 'civic', name: 'Honda Civic', detail: 'À renouveler', icon: 'car', active: false },
]

export const familyMembers: FamilyMember[] = [
  {
    id: 'marianne',
    firstName: 'Marianne',
    lastName: 'Caldwell',
    role: 'Titulaire',
    initials: 'MC',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3ed6e46d-2ab5-4f53-8f0e-9919328bc5b5.jpg',
    canEdit: true,
  },
  {
    id: 'eric',
    firstName: 'Éric',
    lastName: 'Lavoie',
    role: 'Conjoint',
    initials: 'ÉL',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6d75bf83-2bf9-4f1d-8912-8fecf05ffaa8.jpg',
    canEdit: false,
  },
  {
    id: 'emma',
    firstName: 'Emma',
    lastName: 'Lavoie',
    role: 'Enfant',
    initials: 'EL',
    hasCard: false,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/34fafd9b-c877-4154-8e6b-5e158dfa521f.jpg',
    canEdit: true,
  },
]
